module.exports = __webpack_public_path__ + "img/page-02.12fa15f6.jpg";